import { Stack } from '@mui/material';

// TODO (TODO) get rid of 'any' type
export const ToDoItem = (props: any) => {
  return <Stack spacing={2}>{props.task || ''}</Stack>;
};
